import usePermission from "./../../../hooks/usePermission";
import { Dropdown, Space, Popconfirm } from 'antd';
import { EditOutlined, SafetyCertificateOutlined, DownOutlined, DeleteOutlined } from '@ant-design/icons';

const DropdownActionsTable = ({ record, openDialogFilesWithParams, edit, AuthRelationship, deleteRelationship }) => {
    const canAutorizarN1 = usePermission({ permission: 'autorizacion_n1_relacion' });
    const canAutorizarN2 = usePermission({ permission: 'autorizacion_n2_relacion' });

    const items = getDropdownItems(record, canAutorizarN1, canAutorizarN2, deleteRelationship);

    return (
        <Dropdown
            menu={{
                items,
                onClick: ({ key }) => {
                    if (key === '1') openDialogFilesWithParams(record);
                    if (key === '2') edit(record);
                    if (key === '3') AuthRelationship(record, "autorizacion_n1");
                    if (key === '4') AuthRelationship(record, "autorizacion_n2");
                },
            }}
            >
            <a onClick={e => e.preventDefault()}>
                <Space>
                    Ver acciones
                    <DownOutlined />
                </Space>
            </a>
        </Dropdown>
    );
}

const getDropdownItems = (record, canAutorizarN1, canAutorizarN2, deleteRelationship) => {
    const items = [
        {
            key: '1',
            label: <a>Ver archivos</a>,
        },
        {
            key: '2',
            label: <a>Editar relación</a>,
            icon: <EditOutlined />,
        },
        {
            key: '5',
            icon: <DeleteOutlined />,
            label: (
                <Popconfirm
                    title="¿Estás seguro de eliminar esta relación?"
                    okText="Sí"
                    cancelText="No"
                    onConfirm={() => deleteRelationship(record)}
                >
                    <a style={{ color: 'red' }}>Eliminar relación</a>
                </Popconfirm>
            ),
        },
    ];

    if (record.estatus !== "AUTORIZADO" && record.autorizacion_n1 === 0 && canAutorizarN1) {
        items.push({
            key: '3',
            label: <a>Autorizar N1</a>,
            icon: <SafetyCertificateOutlined />,
        });
    }

    if (record.estatus !== "AUTORIZADO" && record.autorizacion_n1 === 1 && canAutorizarN2) {
         items.push({
            key: '4',
            label: <a>Autorizar N2</a>,
            icon: <SafetyCertificateOutlined />,
        });
    }

    return items;
};

export default DropdownActionsTable;